import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import ItemsManager from './ItemsManager';
import OrdersManager from './OrdersManager';
import './AdminDashboard.css';

const AdminDashboard = () => {
  return (
    <div className="admin-dashboard">
      <div className="admin-sidebar">
        <h2>Admin Panel</h2>
        <nav className="admin-nav">
          <NavLink
            to="/admin"
            end
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            Items
          </NavLink>
          <NavLink
            to="/admin/orders"
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            Orders
          </NavLink>

        </nav>
      </div>

      <div className="admin-content">
        <Routes>
          <Route index element={<ItemsManager />} />
          <Route path="orders" element={<OrdersManager />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminDashboard;
